// this.$store.state.infografia
import { db } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";
import { colecciones } from "../constantes";

// INFOGRAFIA
export const infografia = {
  registro: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idUsuario: "",
          idEmpresa: "",
          nombre: "",
          cuestionario: {
            tiene: "",
            id: "",
            secciones: [],
          },
          archivo: {
            nombre: "",
            tipo: "",
            url: "",
          },
          registro: {
            filtro: moment().format("YYYY-MM-DD"),
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            estado: "Creado",
          },
        };
      }
    },
    funciones: {
      async crear(infografia) {
        await setDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
            infografia.id,
          ),
          infografia,
        );
      },
      async actualizar(infografia) {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
            infografia.id,
          ),
          {
            nombre: infografia.nombre,
            archivo: infografia.archivo,
            cuestionario: infografia.cuestionario,
            "registro.estado": "Editado",
            "registro.filtro": infografia.registro.filtro,
            "registro.actualizacion": serverTimestamp(),
          },
        );
      },
      async eliminar(id) {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
            id,
          ),
          {
            "registro.estado": "Eliminado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      },
      async obtener(id) {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
      async obtenerRegistros(idEmpresa) {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
          ),
          where("idEmpresa", "==", idEmpresa),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs.map((doc) => doc.data())
          : null;
      },
      async generarID() {
        const refInfografia = doc(
          collection(
            db,
            colecciones.firebase.seguridadVial.infografias.registros,
          ),
        );
        return refInfografia.id;
      },
    },
  },
  visualizacion: {
    objeto: class {
      constructor() {
        return {
          id: "",
          idUsuario: "",
          cuestionario: {
            id: "",
            tiene: "",
            secciones: [],
            resultado: "",
          },
          registro: {
            filtro: moment().format("YYYY-MM-DD"),
            creacion: serverTimestamp(),
            actualizacion: serverTimestamp(),
            estado: "Creado",
          },
        };
      }
    },
    funciones: {
      async crear(idInfografia, visualizacion) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        await setDoc(doc(db, coleccion, visualizacion.id), visualizacion);
      },
      async actualizar(idInfografia, visualizacion) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        await updateDoc(doc(db, coleccion, visualizacion.id), {
          cuestionario: visualizacion.cuestionario,
          resultado: visualizacion.resultado,
          "registro.estado": "Editado",
          "registro.actualizacion": serverTimestamp(),
        });
      },
      async eliminar(idInfografia, idVisualizacion) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        await updateDoc(doc(db, coleccion, idVisualizacion), {
          "registro.estado": "Eliminado",
          "registro.actualizacion": serverTimestamp(),
        });
      },
      async obtener(idInfografia, idVisualizacion) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        const q = query(
          collection(db, coleccion),
          where("id", "==", idVisualizacion),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
      async obtenerPorIdUsuario(idInfografia, idUsuario) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        const q = query(
          collection(db, coleccion),
          where("idUsuario", "==", idUsuario),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      },
      async generarID(idInfografia) {
        const coleccion = `/${colecciones.firebase.seguridadVial.infografias.registros}/${idInfografia}/visualizaciones`;
        const refVisualizacion = doc(collection(db, coleccion));
        return refVisualizacion.id;
      },
    },
  },
};
